import React from "react";
import DotPattern from "./svg/DotPattern";

const RightPanelDecor = () => (
  <div className="login-right-decor" aria-hidden="true">
    <DotPattern variant="light" />
  </div>
);

export default RightPanelDecor;
